<mat-card class="m-4">
  <mat-card-header>
    <mat-card-title style="font-size: 20px;font-weight: 500;">DESPACHO</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    Mover
    <form [formGroup]="formDespacho">
      <div class="grid grid-cols-2 gap-4">
        <mat-form-field class="flex-grow">
          <mat-label>Nueva Forma de Envío</mat-label>
          <mat-select
            (valueChange)="loadData()"
            formControlName="tipo_forma_envio"
            name="tipo_forma_envio">
            <mat-option *ngFor="let tipo of tipoDespacho" [value]="tipo.id">
              {{ tipo.descripcion }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field
          class="flex-grow"
          *ngIf="formDespacho?.get('tipo_forma_envio')?.value">
          <mat-label>Tema</mat-label>
          <input
            matInput
            type="text"
            name="nombreTema"
            formControlName="nombreTema" />
        </mat-form-field>
      </div>
      <div *ngIf="formDespacho.get('tipo_forma_envio')?.value">
        @if (getContador(formDespacho.get("descripcionTema_html")?.value)<=0&&
        formDespacho.get("descripcionTema_html")?.touched) {
        <p class="!m-0 descripcionTema_html_error !text-sm ">Descripción del tema*</p>
        }@else {
        <p class="!m-0 descripcionTema_html !text-sm">Descripción del tema*</p>
        }

        <section class="border border-t-gray-300">
          <ngx-editor-menu
            [editor]="editor"
            [toolbar]="toolbar"></ngx-editor-menu>
          <ngx-editor
            (ngModelChange)="onEditorChange($event)"
            [editor]="editor"
            formControlName="descripcionTema_html"
            placeholder=""></ngx-editor>
        </section>
        <div class="!flex !item-end !justify-between">
          @if(getContador(formDespacho.get("descripcionTema_html")?.value)<=0&&
          formDespacho.get("descripcionTema_html")?.touched) {
          <p class="!m-0 descripcionTema_html_error">Campo obligatorio</p>
          }@else {
          <p class0="!m-0 "></p>
          }
          <mat-hint align="end">
            {{ getContador(formDespacho.get("descripcionTema_html")?.value) }} /
            50000</mat-hint
          >
        </div>
        <mat-slide-toggle
          formControlName="banEsImpreso"
          name="banEsImpreso"
          labelPosition="before"
          hideIcon="true"
          class="mb-5 mt-5"
          [color]="'primary'">
          Impreso
        </mat-slide-toggle>
        <div
          *ngIf="
            temaAMover &&
            temaAMover?.entradas &&
            temaAMover?.entradas.length > 0
          "
          class="grid grid-cols-2 gap-4 border border-gray-300 border-b-0 p-2">
          <p class="col-span-1 m-0 text-gray-800">Entrada</p>

          <p class="col-span-1 m-0 text-gray-800">Entregables</p>
        </div>

        @for (entrada of temaAMover?.entradas; track $index) {
        <div class="grid grid-cols-2 gap-4 border border-gray-300 p-2">
          <a
            routerLink="/entrada/{{ entrada.id_categorizacion }}/{{
              entrada.id_entrada
            }}"
            target="_blank"
            class="entradaLink !underline"
            [matTooltip]="entrada.nombreEntrada"
            matTooltipPosition="above"
            aria-label="nombre de la entrada"
            class="col-span-1 m-0 !underline blue-color"
            >{{ entrada.nombreEntrada }}</a
          >
          <div class="col-span-1">
            @for (entregable of entrada.entregables; track $index) { @if
            (entregable?.nombreEntregable) {
            <a
              target="_blank"
              [href]="entregable.urlEntregable"
              class="m-0 !underline blue-color !cursor-pointer"
              title="{{ entregable?.nombreEntregable }}">
              {{
                entregable?.nombreEntregable.length > 22
                  ? entregable?.nombreEntregable.substring(0, 22) + "..."
                  : entregable?.nombreEntregable
              }}
            </a>
            <br />
            } @else {

            <a
              (click)="descargarEntregable(entregable, entrada)"
              class="m-0 !underline blue-color !cursor-pointer"
              >Adjuntar archivo</a
            >
            <br />
            } }
          </div>
        </div>

        }

        <div class="grid grid-cols-2 gap-4 mt-4">
          <div class="flex items-center gap-2">
            <mat-form-field class="flex-grow" *ngIf="!mostrarCalendario">
              <mat-label>Fecha del acuerdo</mat-label>
              <mat-select
                required
                (valueChange)="setFechaAcuerdo($event)"
                formControlName="id_forma_envio"
                name="id_forma_envio">
                <mat-option
                  *ngFor="let tipo of catFormaEnvio |  ascDesc: 'fechaAcuerdo':'asc'"
                  [value]="tipo.idFE">
                  {{ tipo.fechaAcuerdo | date : "dd-MM-YYYY" : "UTC" }}
                </mat-option>
              </mat-select>
              @if ( formDespacho.get('id_forma_envio')?.touched && formDespacho
              .get('id_forma_envio')?.hasError('required')) {
              <mat-error>Campo obligatorio</mat-error>
              }
            </mat-form-field>
            <mat-form-field class="flex-grow" *ngIf="mostrarCalendario">
              <mat-label>Fecha del acuerdo</mat-label>
              <input
                required
                (dateChange)="validarFecha($event)"
                formControlName="fechaAcuerdoDate"
                name="fechaAcuerdoDate"
                matInput
                [min]="minDate"
                [matDatepicker]="picker" />
              <mat-datepicker-toggle
                matIconPrefix
                [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              @if ( formDespacho.get('fechaAcuerdoDate')?.touched &&
              formDespacho .get('fechaAcuerdoDate')?.hasError('required')) {
              <mat-error>Campo obligatorio</mat-error>
              }
            </mat-form-field>
            <mat-icon
              class="flex-none"
              *ngIf="!mostrarCalendario"
              (click)="mostrarCalendario = true; setFecha('id_forma_envio')"
              aria-hidden="false"
              aria-label="Example home icon"
              fontIcon="event_available"></mat-icon>
            <mat-icon
              class="flex-none"
              *ngIf="mostrarCalendario"
              (click)="mostrarCalendario = false; setFecha('fechaAcuerdoDate')"
              aria-hidden="false"
              aria-label="Example home icon 2"
              fontIcon="list_alt"></mat-icon>
          </div>

          <mat-form-field class="flex-grow">
            <mat-label>Tipo</mat-label>
            <mat-select formControlName="id_tipo_tema" name="id_tipo_tema">
              <mat-option *ngFor="let tipo of catTipoTema" [value]="tipo.id">
                {{ tipo.descripcion }}
              </mat-option>
            </mat-select>
            @if ( formDespacho.get('id_tipo_tema')?.touched && formDespacho
            .get('id_tipo_tema')?.hasError('required')) {
            <mat-error>Campo obligatorio</mat-error>
            }
          </mat-form-field>

          <mat-slide-toggle
            (change)="setCategorizaacion()"
            hideIcon="true"
            name="banEsConfidencial"
            formControlName="banEsConfidencial"
            class="flex-grow"
            [color]="'primary'"
            labelPosition="after">
            Confidencial
          </mat-slide-toggle>

          <mat-form-field class="flex-grow">
            <mat-label>Categorización</mat-label>
            <mat-select
              formControlName="id_categorizacion"
              name="id_categorizacion">
              <mat-option
                  [disabled]="
                    formDespacho.get('banEsConfidencial')?.value
                      ? cat.descripcion == 'C'
                      : cat.descripcion !== 'C'
                  "
                *ngFor="let cat of catCategorizacion"
                [value]="cat.id">
                {{ cat.descripcion }} - {{ cat.descripcionCompleta }}
              </mat-option>
            </mat-select>
            @if ( formDespacho.get('id_categorizacion')?.touched && formDespacho
            .get('id_categorizacion')?.hasError('required')) {
            <mat-error>Campo obligatorio</mat-error>
            }
          </mat-form-field>

          <mat-form-field class="flex-grow">
            <mat-label>Categoría</mat-label>
            <mat-select formControlName="id_categoria" name="id_categoria">
              <!-- @for (cat of catCategoria; track $index) {
              <mat-option class="grow" [value]="cat.id">
                <div class="flex items-center gap-1 px-1">
                  <div [ngClass]="'bullet bullet-' + cat.id"></div>
                  {{ cat.descripcion }}
                </div>
              </mat-option>
              } -->

              <mat-select-trigger class="trigger-container">
                <div
                  class="bullet color-{{
                    formDespacho.get('id_categoria')?.value
                  }}"></div>
                <div class="description">
                  {{
                    getCategoriaDescripcion(
                      formDespacho.get("id_categoria")?.value
                    )
                  }}
                </div>
              </mat-select-trigger>
              <mat-option *ngFor="let cat of catCategoria" [value]="cat.id">
                <div class="option-container">
                  <div class="bullet color-{{ cat.id }}"></div>
                  <div class="description">{{ cat.descripcion }}</div>
                </div>
              </mat-option>
            </mat-select>
            @if ( formDespacho.get('id_categoria')?.touched && formDespacho
            .get('id_categoria')?.hasError('required')) {
            <mat-error>Campo obligatorio</mat-error>
            }
          </mat-form-field>
        </div>
        <p class="!mt-2">Responsables del tema</p>
        <div class="grid grid-cols-3 gap-4">
          <mat-form-field class="w-full">
            <mat-label>Analista</mat-label>
            <mat-select
              formControlName="id_fb_resp_analista"
              name="id_fb_resp_analista">
              <mat-option
                *ngFor="let cat of catAnalista | orderBy : 'nombre'"
                [value]="cat.idFB">
                {{ cat.nombre }}
              </mat-option>
            </mat-select>
            @if ( formDespacho.get('id_fb_resp_analista')?.touched &&
            formDespacho .get('id_fb_resp_analista')?.hasError('required')) {
            <mat-error>Campo obligatorio</mat-error>
            }
          </mat-form-field>

          <mat-form-field class="w-full">
            <mat-label>Supervisor</mat-label>
            <mat-select
              formControlName="id_fb_resp_supervisor"
              name="id_fb_resp_supervisor">
              <mat-option
                *ngFor="let cat of catSupervisor | orderBy : 'nombre'"
                [value]="cat.idFB">
                {{ cat.nombre }}
              </mat-option>
            </mat-select>
            @if ( formDespacho.get('id_fb_resp_supervisor')?.touched &&
            formDespacho .get('id_fb_resp_supervisor')?.hasError('required')) {
            <mat-error>Campo obligatorio</mat-error>
            }
          </mat-form-field>
          <mat-form-field class="w-full">
            <mat-label>Coordinador</mat-label>
            <mat-select
              formControlName="id_fb_resp_coordinador"
              name="id_fb_resp_coordinador">
              <mat-option
                *ngFor="let cat of catCoordinador | orderBy : 'nombre'"
                [value]="cat.idFB">
                {{ cat.nombre }}
              </mat-option>
            </mat-select>
            @if ( formDespacho.get('id_fb_resp_coordinador')?.touched &&
            formDespacho .get('id_fb_resp_coordinador')?.hasError('required')) {
            <mat-error>Campo obligatorio</mat-error>
            }
          </mat-form-field>
        </div>
        <div class="flex justify-end gap-4">
          <button mat-stroked-button (click)="cancelar()">CANCELAR</button>
          <button
            [disabled]="
              !(
                formDespacho.valid &&
                (formDespacho.get('id_forma_envio')?.value ||
                  formDespacho.get('fechaAcuerdoDate')?.value)
              )
            "
            color="primary"
            class="full-width-button"
            (click)="guardar()"
            mat-flat-button
            color="primary">
            GUARDAR
          </button>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-card>
